module.exports = __webpack_public_path__ + "static/media/icon_pdf.5e303968.svg";